import { configureStore } from "@reduxjs/toolkit";
import deepmerge from "deepmerge";
import {
  getSessionStorage,
  resetSessionStorage
} from "../sessionAndLocalStorage";
import rootReducer from "./slices";

const storedState = getSessionStorage("state") || {};
const imagesWithoutBlob = getSessionStorage("images");
const isProduction =
  process.env.NODE_ENV === "prd" || process.env.NODE_ENV === "production";

const urlParams = new URLSearchParams(window.location.search);
const appraisalSessionIdFromUrl = urlParams.get("appraisalSessionId");

const appraisalSessionIdFromStoredState =
  storedState?.appraisal?.data?.appraisalSessionId;

const storedStateShouldBeUsed =
  !appraisalSessionIdFromUrl ||
  appraisalSessionIdFromStoredState === appraisalSessionIdFromUrl;

let storeOptions = {
  reducer: rootReducer,
  devTools: !isProduction
};

if (storedStateShouldBeUsed) {
  const preloadedState = deepmerge(imagesWithoutBlob, storedState);
  storeOptions = { ...storeOptions, preloadedState };
} else {
  resetSessionStorage();
}

const store = configureStore(storeOptions);

export default store;
